import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { Avatar, Paper } from "@material-ui/core";
import SimpleDialogDemo from "../../Modals/SimpleDialog";
import FormRender from "../../../Fields/FormRender";
import createEventConfig from "./EventCreate/createEventconfig.json";
import { updateEventAttribute } from "../../../../data-store/actions/events-actions";
import EditableField from "../../../EditableField/EditableField";
import QRWithBackground from "./QRWithBackground";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: "20px",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
}));

export default function EventUpdateGeneralData() {
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const eventDetail = useSelector((state) => state.events.eventDetail);

  const createEventObject = createEventConfig.organizador;

  const classes = useStyles();

  function handleChange(value) {
    console.log(value);
    dispatch(
      updateEventAttribute(
        "evento_" + eventDetail.iDEvento,
        "detalleEvento/organizador/",
        value
      )
    );
  }
  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Grid container direction="column" alignItems="center">
          <Grid item xs={12}>
            <Typography gutterBottom variant={"h4"} component="h2">
              Datos del organizador
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} style={{ margin: "20px" }}>
            {Object.values(createEventObject).map((field, index) => {
              return (
                <EditableField
                  key={index}
                  fieldObject={{
                    ...field,
                    defaultValue:
                      eventDetail.organizador[field.fieldName] !== undefined
                        ? eventDetail.organizador[field.fieldName]
                        : "",
                  }}
                  onSubmit={handleChange}
                />
              );
            })}

            <Grid item xs={12}>
              <Typography gutterBottom variant={"h4"} component="h2">
                QR del link del evento
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <QRWithBackground
                qrValue={
                  eventDetail.organizador.linkEvento ||
                  "https://dashport.run/evento_" + eventDetail.iDEvento
                }
                backgroundImage="https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/FotosFondo%2FQR%20Dashport%20en%20blanco.png?alt=media&token=e20a6636-0f5b-4cfa-8d0f-cb4d34a32168"
                qrSize={500} // Puedes cambiar el tamaño del QR si lo necesitas
                fileName={"QR-" + (eventDetail.nombreEvento || eventDetail.iDEvento) + ".png"}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
}
